import { Button, Typography,Spin } from "antd";
import React, { useState } from "react";
import { formatString } from "../Common/ColorCode";
import moment from "moment";
import { capitalizeFirst, filterByNonGpProductId } from "../Common/CommonFunction";
import "./BookingForm.css";
import ClinicMap from "../Dashboard/ClinicMap";
import axios from "axios";
import { Config } from "../Common/Config";
import {  message } from "antd";
import { Modal,Divider,Grid } from "antd";
import { capitalizeWords } from "../Common/CommonFunction";

const { Title } = Typography;

const BookingDetailsNext = (props) => {
  const [step, setStep] = useState("default"); // default | confirm_cancel | confirm_reschedule
  const [actionState, setActionState] = useState(null); // 'cancel' | 'reschedule'
  const [cancelled, setCancelled] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
  const rawDate = props?.showAppoinmentData?.slot?.date;
     const [selectedDuration, setSelectedDuration] = useState({
        duration: 1,
        gender: "no_preference",
        language: { label: "English", value: "1" },
      });
  const steps=props.step;
  const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    

    
    function appointmentForm(type) {
    props.secondCallback(selectedDuration, type); 
  }

    const [loading, setLoading] = useState(false);
const [statusMessage, setStatusMessage] = useState({ type: "", text: "" });

const [showConfirmDialog, setShowConfirmDialog] = useState(false);

function isDateTimeInPast(datetimeString) {
  const inputDateTime = new Date(datetimeString);
  const currentDateTime = new Date();
  
  return inputDateTime < currentDateTime;
}
  const handleActionClick = (type) => {
    const exist=isDateTimeInPast(props?.showAppoinmentData?.slot?.date +" "+ props?.showAppoinmentData?.slot?.info?.start_time);
    if (exist) {
      messageApi.error({ type: 'error', content: `Appointments in the past cannot be ${type === "cancel" ? "cancelled" : "rescheduled"}`})

      return ;
    }
    setActionState(type);
    setStep(type === "cancel" ? "confirm_cancel" : "confirm_reschedule");
  };

  const handleGoBack = () => {
    setStep("default");
    setActionState(null);
  };

  // const handleProceed = async() => {
  //   if (actionState === "cancel") {

  //     setLoading(true);
  //     setCancelled(false);
  //     setStatusMessage({ type: "", text: "" });
  //     // here changes
  //    let cancelDummyData={
  //       "delete_note" : "test-cancel",
  //       "override_charges" : 0,
  //       "cancellation_charges" : props?.showAppoinmentData?.cancellation_charge
  //     }
  //     try {
  //       const responce=await axios.delete(`${Config.urlOpen}appointments/cancel/${props?.appointMentId || null}`,cancelDummyData)
  //       if (responce.data) {
  //         messageApi.success('Your appointment has been cancelled successfully.');
  //         setCancelled(true);
  //         setStatusMessage({ type: "success", text: 'Your appointment has been cancelled successfully.' });
  //         setStep("default");
  //         props?.handleCancelAppointment?.();
  //       }
  //     } catch (error) {
  //           messageApi.error({ type: 'error', content: 'Your appointment cancelation failed.' });
  //       // alert("api is fail")
  //     } finally {
  //       setLoading(false);
  //     }



  //   } else if (actionState === "reschedule") {
  //     props?.handleRescheduleAppointment?.();
  //     setStep("default");
  //     setActionState(null);
  //   }
  // };

  const handleProceed = async() => {
    if (actionState === "cancel") {
      setShowConfirmDialog(true); // Show our custom dialog instead of proceeding directly
    } else if (actionState === "reschedule") {
      props?.handleRescheduleAppointment?.();
      setStep("default");
      setActionState(null);
    }
  };


  const confirmCancellation = async () => {
    setShowConfirmDialog(false);
    setLoading(true);
    setCancelled(false);
    setStatusMessage({ type: "", text: "" });
    
    let cancelDummyData = {
      "delete_note": "test-cancel",
      "override_charges": 0,
      "cancellation_charges": props?.showAppoinmentData?.cancellation_charge
    }
    
    try {
      // console.log("deletingByid", props.appointMentId)
      const response = await axios.delete(
        `${Config.urlOpen}appointments/cancel/${props?.appointMentId || 24}`,
        { data: cancelDummyData }
      );
      
      if (response.data) {
        messageApi.success('Your appointment has been cancelled successfully.');
        setCancelled(true);
        setStatusMessage({ 
          type: "success", 
          text: 'Your appointment has been cancelled successfully.' 
        });
        setStep("default");
        props?.handleCancelAppointment?.();
      }
    } catch (error) {
      messageApi.error({ 
        type: 'error', 
        content: 'Your appointment cancellation failed.' 
      });
    } finally {
      setLoading(false);
    }
  };

  const renderConfirmation = () => {
    const isCancel = step === "confirm_cancel";
    const charge = isCancel
      ? props.showAppoinmentData.cancellation_charge
      : props.showAppoinmentData.rescheduling_charge;
  
    const actionTypeText = isCancel ? "Cancellation" : "Rescheduling";
  
    return (
      <div style={{ textAlign: "center", marginTop: 20, position:"relative" }}>
        <p style={{ fontSize: 16 }}>
          {actionTypeText} charge of{" "}
          <span
            style={{
              backgroundColor: "rgba(0, 131, 133, 0.25)", // #008385 at 25% opacity
              padding: "2px 6px",
              borderRadius: "5px",
            }}
          >
            £{charge}
          </span>{" "}
          will apply.
        </p>
        <div className="bottomButtons" style={{ display: "flex", justifyContent: "center", marginTop: 5,alignItems: "center" }}>
                      <Button
                        className="transparentBtn"
                        onClick={handleProceed}
                        style={{height:"30px",width:"283px"}}
                      >
                        {capitalizeWords(
                            loading
                              ? 'Cancelling...'
                              : isCancel
                              ? 'Proceed to Cancel'
                              : 'Proceed to Reschedule'
                          )}
                      </Button>
                      <Button
                        // className="darkBtn"
                        className="transparentBtn"
                        style={{ borderColor: "#008385",height:"30px",width:"283px"}}
                        onClick={handleGoBack}                      >
                        {capitalizeWords(" Go Back")}
                      </Button>
                    </div>
  
        {/* <div style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
          <Button
            type="primary"
            onClick={handleProceed}
            style={{ minWidth: 180 }}
          >
            {loading ? "Cancelling..." : isCancel ? "Proceed to Cancel" : "Proceed to Reschedule"}
          </Button>
          <Button onClick={handleGoBack} style={{ minWidth: 180 }}>
            Go Back
          </Button>
        </div> */}

        {showConfirmDialog && (
          <div style={{
            position: 'absolute',
            top: '-120px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '300px',
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            zIndex: 1000,
            border: '1px solid #ddd'
          }}>
            <p style={{ marginBottom: '15px', fontSize: '16px' }}>
              Are you sure you want to cancel this appointment?
            </p>
            <div style={{ 
              backgroundColor: 'rgba(0, 131, 133, 0.25)',
              padding: '8px',
              borderRadius: '4px',
              marginBottom: '15px'
            }}>
              Cancellation charge: £{props?.showAppoinmentData?.cancellation_charge}
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
              <button
                onClick={() => setShowConfirmDialog(false)}
                style={{
                  padding: '8px 16px',
                  backgroundColor: 'rgba(0, 131, 133, 0.25)',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                No
              </button>
              <button
                onClick={confirmCancellation}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#ffcccc',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  color: '#d32f2f'
                }}
              >
                Yes, Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };
  

  let tempDataForDuration = [];

  if (props.showAppoinmentData && props.showAppoinmentData.duration) {
    tempDataForDuration.push({
      key: "Duration",
      data:
        props.data &&
        props.data.durationObjectById &&
        props.showAppoinmentData.duration &&
        props.data.durationObjectById[props.showAppoinmentData.duration]
          ? props.data.durationObjectById[props.showAppoinmentData.duration].duration + " minutes"
          : "15 minutes",
    });
  }

  if (props.showAppoinmentData && props.showAppoinmentData.price) {
    tempDataForDuration.push({
      key: "Price",
      data: props.showAppoinmentData.price
        ? capitalizeFirst(props.showAppoinmentData.price)
        : "",
    });
  }
  // console.log("encccccccc", props?.encryptBookingDetails?.language_name)
  if (props?.showAppoinmentData && props?.showAppoinmentData?.language &&  props?.encryptBookingDetails?.language_name != null  ) {
    let data = props.showAppoinmentData.language?.value || props.showAppoinmentData.language;
    let languageName = props.data.languageData.find((landata) => landata.value == data);
    tempDataForDuration.push({
      key: "Language",
      data: languageName ? languageName.label : data,
    });
  }

  if (props?.showAppoinmentData && props?.showAppoinmentData?.gender && props?.encryptBookingDetails?.preferred_gender != null ) {
    tempDataForDuration.push({
      key: "Gender",
      data: capitalizeFirst(props?.showAppoinmentData?.gender),
    });
  }

  // new
  // if (props?.showAppoinmentData && props?.showAppoinmentData?.language) {
  //   tempDataForDuration.push({
  //     key: "Language",
  //     data: capitalizeFirst(props?.showAppoinmentData?.language)
  //   });
  // }
  
  // if (props?.showAppoinmentData && props?.showAppoinmentData?.gender) {
  //   tempDataForDuration.push({
  //     key: "Gender",
  //     data: capitalizeFirst(props?.showAppoinmentData?.gender)
  //   });
  // }

  function getProductName(id) {
    let products;
  
    // Try to load from localStorage and parse to object
    const stored = localStorage.getItem('nongroupproductid');
    if (stored) {
      try {
        products = JSON.parse(stored); // parse string to object
      } catch (e) {
        console.error("Invalid JSON in localStorage");
        products = {}; // fallback to empty object on error
      }
    } else {
      // Fallback if nothing in localStorage
      products = {
        201: "Vital",
        202: "Bronze",
        203: "Silver",
        204: "Gold",
        205: "Platinum",
        4: "Vital (15 minutes)",
        5: "Bronze (60 minutes)",
        6: "Gold (90 minutes)",
        7: "Silver (75min)",
        10: "Platinum",
        18: "r888",
        20: "r888178",
        22: "Diamond"
      };
    }
  
    return products[id];
  }

  return (
    <div>
            {contextHolder}
      {/* Header Section */}
      {props?.showAppoinmentData?.Loading? <Spin className="custom-spinner" />:<>
      <div style={{ display: "flex", justifyContent: "center",alignItems:"center",gap:!screens.md || steps === 1 ?  "0px":"10px",flexDirection:!screens.md || steps === 1 ? 'column' : 'row',marginTop:!screens.md || steps === 1 ?  "0px":"40px" }}>
        {steps==2 && (<div
        className="textalign"
            style={{
              backgroundColor: "rgba(0, 131, 133, 0.25)",
              color: "#008385",
              padding: "16px 8px",
              fontWeight: "400",
              fontSize: "18px",
              width:!screens.md || steps === 1 ? "-webkit-fill-available":"182px"
            }}
          >
            Original booking:
          </div>)}
        
        <div className="widthSet" style={{
          background: "#F0FAFA",
          // padding: 10,
          marginTop:screens?.md? 0: 25,
          border: "1px solid #008385",
          height: "76px",
          maxWidth:!screens?.md || steps === 1 ? "394px":"287px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          borderBottom:(!screens?.md || steps === 1)?"none":"1px solid #008385",
        }}>
          <span style={{ fontSize: 14, color: "#008385" }}>
            {props?.showAppoinmentData?.clinic?.productCategory?.title || "General GP consultation"}
          </span>
          {/* {props?.showAppoinmentData?.clinic?.productCategory?.product_category_id == 2 && <br />} */}
          {props?.showAppoinmentData?.clinic?.productCategory?.product_category_id == 2 && (
            <span style={{ fontSize: 14, color: "#008385" }}>
              {
                filterByNonGpProductId(
                  props.getAllHealthScreenData?.getAllHealthScreenData?.data || [],
                  props?.showAppoinmentData?.clinic?.non_gp_product_id
                )?.[0]?.name || ""
              }
            </span>
          )}
          {/* <br /> */}
          {tempDataForDuration.length && props?.showAppoinmentData?.clinic?.productCategory?.product_category_id !== 2 ? (
            <>
              {[0, 2].map((startIdx) => (
                <div key={startIdx}>
                  {tempDataForDuration.slice(startIdx, startIdx + 2).map((rs, i, arr) => (
                    <React.Fragment key={i}>
                      <span style={{ color: "#000", fontSize: 13 }}>{rs.key}:</span>
                      <span style={{ fontSize: 13, color: "#008385" }}>
                        {rs.data}
                        <span style={{ color: "#000" }}>{i !== arr.length - 1 ? " | " : ""}</span>
                      </span>
                    </React.Fragment>
                  ))}
                </div>
              ))}
              {/* not going to affect any where  */}
            </>
          ) : null}

            {

            props?.showAppoinmentData?.clinic?.productCategory
            ?.product_category_id  == 2 ? (
            <span style={{ fontSize: 14, color: '#008385', padding:5 }}>
                {getProductName(props?.showAppoinmentData?.clinic?.non_gp_product_id)  }
                {` | Price:  ${props?.showAppoinmentData?.price  }`}
                
            </span>) : (null)
            }


        </div>

        {/* Date Section */}
        <div className="widthSet" style={{
          background: "#F0FAFA",
          // padding: 10,
          border: "1px solid #008385",
          // borderTop: "0",
          height: "76px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop:"0px",
          maxWidth:!screens.md || steps === 1 ? "394px":"287px",
        }}>
          <span style={{ fontWeight: "500", fontSize: 20, color: "rgba(74, 74, 74, 1)" }}>
            {props?.showAppoinmentData?.slot?.date
              // ? moment(props.showAppoinmentData.slot.date).format("D MMMM, YYYY")
              ? rawDate 
              : ''}{" "} |{" "}
            {props?.showAppoinmentData?.slot?.info?.start_time || ""}
          </span>
        </div>

        {/* Clinic Info */}
        <div style={{
          maxWidth:"394px",
          width:screens?.md? "394px":"93vw",
          height: "76px",
          display: "flex",
          justifyContent: "flex-start",
          marginTop:!screens?.md || steps === 1 ?  20:0,
          padding: screens?.md?"10px 0px":"0px"
        }}>
          <div style={{ width: 90, height: 90, borderRadius: "10px" }}>
            <ClinicMap
              widthAndheight={{ width: 76, height: 76 }}
              passData={{
                cood: [{
                  id: props.showAppoinmentData?.slot?.clinicData?.id,
                  name: props.showAppoinmentData?.slot?.clinicData?.name,
                  data: [
                    props.showAppoinmentData?.slot?.clinicData?.latitude,
                    props.showAppoinmentData?.slot?.clinicData?.longitude,
                  ],
                }],
              }}
            />
          </div>
          <div style={{ textAlign: "left", marginLeft: 30 }}>
            <p style={{ fontSize: 14, marginTop: 0 }}>{props.showAppoinmentData?.slot?.clinicData?.name || ""}</p>
            <p style={{ fontSize: 14 }}>{props.showAppoinmentData?.slot?.clinicData?.address || ""}</p>
          </div>
        </div>
      </div>
      <div style={{display:"flex", justifyContent:"center",width:!screens.md  ? "-webkit-fill-available":"605px",margin:"auto"}}> 
              {steps==1 && (
                <Divider 
                style={{
                  borderColor: 'rgb(74, 74, 74)',
                  borderWidth: '1px 0 0 0', // only top border is visible by default
                  width: '100px',
                }} />
              )}
              </div>
      
      
              
      {/* Cancelled Message */}
      {cancelled && (
        <div style={{ color: 'rgba(197, 0, 0, 1)', borderTop:"1px solid gray", width:"fit-content", marginInline:"auto", padding:"4px", textAlign: 'center', marginBottom: 10 }}>
          <strong>This appointment has now been cancelled.</strong>

        </div>
      )}

      {/* Action Buttons */}
      {!props?.hide && (
        <>
          {step === "default" && !cancelled && (
                    <div className="bottomButtons" style={{ display: "flex", justifyContent: "center", marginTop: 5,alignItems: "center" }}>
                      <Button
                        className="transparentBtn"
                         onClick={() => handleActionClick("cancel")}
                         style={{height:"30px",width:"283px"}}
                      >
                        <div style={{display:"flex",flexDirection:screens.md?"row": "column",justifyContent:"center",alignItems:"center",gap:screens.md?"7px":"0px"}}>
                                  <span> {capitalizeWords("Cancel this ")}</span>
                                  <span>{capitalizeWords(" appointment")}</span>
                                  </div>
                        {/* {capitalizeWords("Cancel this appointment")} */}
                      </Button>
                      <Button
                        className="transparentBtn"
                        style={{height:"30px",width:"283px" }}
                        onClick={() => handleActionClick("reschedule")}
                      >
                                  <div style={{display:"flex",flexDirection:screens.md?"row": "column",justifyContent:"center",alignItems:"center",gap:screens.md?"7px":"0px"}}>
                                  <span> {capitalizeWords("Reschedule this ")}</span>
                                  <span>{capitalizeWords(" appointment")}</span>
                                  </div>
                        {/* {capitalizeWords("Reschedule this appointment")} */}
                      </Button>
                    </div>
            // <div style={{ display: "flex", justifyContent: "center", marginTop: 5, }} className="buttonChanging">
            //   <Button 
            //     onClick={() => handleActionClick("cancel")}
            //     type="primary"
            //     style={{
            //       // background: "#008385",
            //       // borderColor: "#008385",
            //       height: 40,
            //       marginRight: 10,
            //     }}
            //   >
            //     Cancel this appointment
            //   </Button>
            //   <Button  className="buttonChanging"
            //     onClick={() => handleActionClick("reschedule")}
            //     type="primary"
            //     style={{
            //       background: "#008385",
            //       borderColor: "#008385",
            //       height: 40,
            //     }}
            //   >
            //     Reschedule this appointment
            //   </Button>
            // </div>
          )}

          {step === "confirm_cancel" || step === "confirm_reschedule" ? renderConfirmation() : null}

          {/* Book Again Button */}
          {cancelled && (
            <div style={{ textAlign: "center", marginTop: 20 }}>
              <Button
                type="primary"
                onClick={() => props?.onBookAgain?.()}
              >
                Book Again
              </Button>
            </div>
          )}
        </>
      )}
      </>}
      
    </div>
    
  );
};

export default BookingDetailsNext;
